export class RadarNotFoundError extends Error {
  public readonly availableRadars: { id: string; title: string }[];

  public constructor(
    radarId: string,
    availableRadars: { id: string; title: string }[],
  ) {
    super(`Radar '${radarId}' is not published`);
    this.name = 'RadarNotFoundError';
    this.availableRadars = availableRadars;
  }
}

export class RadarUnavailableError extends Error {
  public constructor(radarId: string, reason: string) {
    super(`Radar '${radarId}' content is unavailable: ${reason}`);
    this.name = 'RadarUnavailableError';
  }
}
